import { render, staticRenderFns } from "./checkbox-button.vue?vue&type=template&id=478e906e&"
import script from "./checkbox-button.vue?vue&type=script&lang=js&"
export * from "./checkbox-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478e906e')) {
      api.createRecord('478e906e', component.options)
    } else {
      api.reload('478e906e', component.options)
    }
    module.hot.accept("./checkbox-button.vue?vue&type=template&id=478e906e&", function () {
      api.rerender('478e906e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/checkbox/src/checkbox-button.vue"
export default component.exports